const initializeStorefrontModules = () => {
  console.log("Initializing storefront modules...");

  globalThis.redoStorefront = {
    type: "commercecloud",
    storeUrl: location.host,
    env: {
      // cspell:disable
      IPIFY_API_KEY: "at_S8q5xe1hwi5jKf6CSb4V661KXTKK2",
      REDO_API_CLIENT_VERSION: "",
      REDO_API_URL: "https://shopify-cdn.getredo.com",
      REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
      REDO_SHOPIFY_EXTENSION_URL: "auto",
      AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
      // cspell:enable
    },
  };
  globalThis.process = { env: {} };
  process.env.IPIFY_API_KEY = "at_S8q5xe1hwi5jKf6CSb4V661KXTKK2";
  process.env.REDO_API_CLIENT_VERSION = "";
  process.env.REDO_API_URL = "https://shopify-cdn.getredo.com";
  process.env.REDO_SHOPIFY_SERVER_URL = "https://shopify-server.getredo.com";
  process.env.REDO_SHOPIFY_EXTENSION_URL = "auto";
  process.env.AMPLITUDE_API_KEY = "4ea5fb67e1313890e096ab17cce5d093";

  void import("@redotech/redo-shopify-extension/index");
  console.log("Redo Commerce Cloud bootstrap v2.");
};

export { initializeStorefrontModules };
